// Filter Types
export const ParentalRelationshipType = [
    { value : "SPOUSE", name: "ESPOSO/A"},
    { value : "PARTNER", name: 'PAREJA'},
    { value : "OFFSPRING", name: "HIJO"},
    { value : "IN_CHARGE", name: "A CARGO"}
 ];